/**
 * ExternalRedirect — client-side hard redirect to a different origin.
 *
 * react-router's <Navigate> only rewrites the SPA's in-app path; it cannot send
 * the browser to another origin (e.g. the public cars-for-sale Stock site). This
 * component performs `window.location.replace(url)` in an effect and renders a
 * minimal "Redirecting…" message so `#root` is never empty even for the single
 * frame before the navigation commits (the white-screen root cause was an empty
 * render for unmatched paths).
 */
import { useEffect } from 'react';

interface ExternalRedirectProps {
  /** Absolute http(s) URL on another origin. */
  url: string;
}

export function ExternalRedirect({ url }: ExternalRedirectProps): JSX.Element {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(url);
    }
  }, [url]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'inherit',
      }}
    >
      <p style={{ margin: 0 }}>
        Redirecting… <a href={url}>Continue to the Stock site</a> if you are not redirected
        automatically.
      </p>
    </div>
  );
}
